var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRuby(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 255,
    viewBox: "0 0 256 255",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M197.467 167.763L51.9463 254.173L240.369 241.387L254.881 51.3926L197.467 167.763Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M240.677 241.258L224.482 129.479L180.369 187.729L240.677 241.258Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M240.896 241.257L122.249 231.943L52.5762 253.93L240.896 241.257Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7438 253.954L82.3832 156.854L17.1611 170.801L52.7438 253.954Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M180.357 188.051L153.085 81.2256L75.0371 154.385L180.357 188.051Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M248.693 82.7301L174.916 22.4736L154.372 88.8921L248.693 82.7301Z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M214.19 0.990553L170.799 24.9696L143.424 0.668945L214.19 0.990553Z",
    fill: "url(#paint6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 203.372L18.1773 170.221L3.47337 130.728L0 203.372Z",
    fill: "url(#paint7_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49609 129.479L17.2901 171.443L81.5731 157.021L154.964 88.814L175.676 23.0271L143.063 0L87.618 20.7502C70.1496 36.9978 36.2521 69.1457 35.03 69.7504C33.8207 70.3678 12.646 110.389 2.49609 129.479Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4412 54.0942C92.3009 16.5561 141.108 -5.62195 159.839 13.2757C178.557 32.1734 158.707 78.099 120.847 115.624C82.9872 153.15 34.7845 176.55 16.067 157.652C-2.66349 138.767 16.5815 91.6195 54.4412 54.0942Z",
    fill: "url(#paint8_linear)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7441 253.916L82.152 156.508L179.818 187.884C144.505 220.997 105.231 248.989 52.7441 253.916Z",
    fill: "url(#paint9_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M155.092 88.6227L180.164 187.935C209.662 156.919 236.137 123.575 249.103 82.332L155.092 88.6227Z",
    fill: "url(#paint10_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M248.848 82.8334C258.882 52.5507 261.197 9.10792 213.881 1.04199L175.057 22.4868L248.848 82.8334Z",
    fill: "url(#paint11_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 202.935C1.38935 252.914 37.448 253.659 52.808 254.098L17.3282 171.237L0 202.935Z",
    fill: "#9E1209"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M155.232 88.7769C177.899 102.709 223.582 130.689 224.508 131.203C225.948 132.014 244.203 100.419 248.346 82.5635L155.232 88.7769Z",
    fill: "url(#paint12_radial)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1133 156.508L121.427 232.356C144.672 219.749 162.875 204.389 179.548 187.935L82.1133 156.508Z",
    fill: "url(#paint13_radial)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1738 171.34L11.6035 237.668C22.1137 252.025 36.5732 253.273 51.7402 252.153C40.7669 224.843 18.8461 170.233 17.1738 171.34Z",
    fill: "url(#paint14_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M174.826 22.6538L252.925 33.6142C248.757 15.9514 235.957 4.55365 214.14 0.990234L174.826 22.6538Z",
    fill: "url(#paint15_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 223.934,
    y1: 277.289,
    x2: 170.227,
    y2: 182.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB7655"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E42B1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#990000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#990000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 250.719,
    y1: 197.542,
    x2: 175.219,
    y2: 182.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#871101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#911209"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#911209"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 195.274,
    y1: 280.166,
    x2: 194.301,
    y2: 232.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#871101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#911209"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#911209"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 49.7803,
    y1: 163.879,
    x2: 72.2285,
    y2: 229.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#E57252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#DE3B20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A60003"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A60003"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 123.668,
    y1: 98.6893,
    x2: 127.74,
    y2: 169.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#E4714E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BE1A0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A80D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A80D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 189.238,
    y1: 32.8307,
    x2: 195.192,
    y2: 84.5743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#E46342"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#C82410"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A80D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A80D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 153.054,
    y1: 14.8474,
    x2: 161.448,
    y2: -20.7461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#C81F11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#BF0905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF0905"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 5.02133,
    y1: 146.081,
    x2: 26.9738,
    y2: 159.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#DE4024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#BF190B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF190B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: -23.8712,
    y1: 199.531,
    x2: 173.398,
    y2: -3.89497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD0012"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#C82F1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#820C01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#A31601"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#B31301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#E82609"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E82609"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 127.453,
    y1: 220.023,
    x2: 71.627,
    y2: 196.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C0C01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#990C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A80D0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A80D0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 229.661,
    y1: 148.602,
    x2: 172.156,
    y2: 107.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E110B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9E0C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E0C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 249.084,
    y1: 61.6677,
    x2: 222.041,
    y2: 34.2157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79130D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#9E120B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E120B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(185.029 102.128) scale(64.7816 33.8509)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A80D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#7E0E08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E0E08"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(95.315 187.499) scale(86.1185 67.0392)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A30C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#800E08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#800E08"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 34.3089,
    y1: 253.859,
    x2: -14.1759,
    y2: 213.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B2114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#9E100A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B3100C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3100C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 198.935,
    y1: 12.604,
    x2: 212.697,
    y2: 47.4182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B31000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#910F08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#791C12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#791C12"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuby);
export default __webpack_public_path__ + "static/media/ruby.34e792ab70448eb69573a8b2df207f74.svg";
export { ForwardRef as ReactComponent };